<template>
  <v-form v-model="form_valido" ref="form" lazy-validation>
    <z-dialogo ref="dialogo" titulo="ChavePix Bancária" :dividers="true" largura="500px" persistent @fechar="onFechar">
      <template #conteudo>
        <v-row dense>
          <v-col cols="12">
            <v-autocomplete 
              v-model="chavePix.tipo" 
              label="Tipo" 
              filled 
              dense
              :rules="[v => !!v || 'Campo obrigatório']" 
              :items="tipos_chave_pix"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <z-text-field 
              label="Chave Pix" 
              v-model="chavePix.chave" 
              filled 
              dense
              :rules="[v => !!v || 'Campo obrigatório']"
            ></z-text-field>
          </v-col>
          <v-col cols="12">
            <z-text-field 
              label="Titular" 
              v-model="chavePix.titular" 
              filled 
              dense
            ></z-text-field>
          </v-col>
        </v-row>
      </template>
      
      <template #actions_right>
        <v-btn text @click="$refs.dialogo.fechar()" :disabled="salvando">
          Cancelar
        </v-btn>
        <v-btn depressed color="primary" @click="salvar" :disabled="!form_valido" :loading="salvando">
          Salvar
        </v-btn>
      </template>
    </z-dialogo>


  </v-form>
</template>

<script setup>
import { ref, computed, getCurrentInstance, onMounted, inject } from 'vue';
import queryBuilder from '@/app/helpers/QueryBuilder';

const { proxy } = getCurrentInstance();
const $store = proxy.$store;
const $globals = proxy.$globals;
const $notificacao = inject('notificacao');

const dialogo = ref(null);
const form = ref(null);
const form_valido = ref(true);
const salvando = ref(false);
const excluindo = ref(false);


onMounted(async () => {
  await $store.dispatch("listas/fetchListas", [
      queryBuilder()
        .from("Banco")
        .selectraw("id as value, concat(codigo, ' - ', descricao) as text")
        .orderBy("codigo")
        .build()
  ]);
});

const tipos_chave_pix = computed(() => {
  return  Object.keys($globals.TIPOS_CHAVE_PIX).map((key) => {
    return {
        text: $globals.TIPOS_CHAVE_PIX[key],
        value: key
    }
  });
});

const chavePix = computed(() => {
  return $store.state.fornecedores.chavepix;
});

const fornecedor = computed(() => {
  return $store.state.fornecedores.fornecedor;
});

function abrir() {
  dialogo.value.abrir();
}

function fechar() {
  onFechar();
  dialogo.value.fechar();
}

function onFechar() {
  $store.commit('fornecedores/LIMPAR_CHAVEPIX');
  form.value.resetValidation();
}

async function salvar() {

  salvando.value = true;
  // console.log("SALVAR CHAVEPIX", chavePix.value);
  try {
    if (chavePix.value.id) {
      await $store.dispatch('fornecedores/atualizarChavePix', chavePix.value);
    } else {
      chavePix.value.fornecedor_id = fornecedor.value.id;
      await $store.dispatch('fornecedores/salvarChavePix', chavePix.value);
    }
    $notificacao.notificar("Chave Pix salva com sucesso!");
  } catch (error) {
    $notificacao.error("Houve um erro ao salvar a Chave Pix", error);
    throw error;
  } finally {
    salvando.value = false;
    dialogo.value.fechar();
  }
}

defineExpose({
  abrir,
  fechar,
});

</script>

<style lang="scss" scoped>

</style>